import { installFreshvibeShim } from "./shim";
import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
// App CSS first: globals.css declares the cascade-layer order (Tailwind preflight
// below the DS layers) — the DS bundle must load after it so that order sticks.
import "./styles/globals.css";
import "@fwf/fwfa-design-system/css";
// Cache-bust: 2026-03-19

import Landing from "./Landing";
import CloudApp from "./CloudApp";
import AdminView from "./AdminView";

const DesignSystemPage = lazy(() => import("./DesignSystemPage"));
const DesignPlayground = lazy(() => import("./DesignPlayground"));

installFreshvibeShim();

/**
 * GCP administration merged into /admin as a provider tab. Rewriting the URL
 * before the first render (rather than `location.replace`, which would refetch
 * the whole bundle and render the tree twice) means the router only ever sees
 * /admin, and AdminView reads the provider straight off the query on mount.
 */
function redirectLegacyRoutes() {
  if (window.location.pathname.startsWith("/gcp-admin")) {
    window.history.replaceState(null, "", "/admin?provider=gcp");
  }
}

redirectLegacyRoutes();

function Router() {
  const path = window.location.pathname;

  if (path.startsWith("/admin")) {
    return <AdminView />;
  }

  if (path.startsWith("/design-playground")) {
    return (
      <Suspense fallback={null}>
        <DesignPlayground />
      </Suspense>
    );
  }

  if (path.startsWith("/design-system")) {
    return (
      <Suspense fallback={null}>
        <DesignSystemPage />
      </Suspense>
    );
  }

  if (path.startsWith("/app")) {
    return <CloudApp />;
  }

  return <Landing />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Router />
  </StrictMode>
);
